import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  idStatement: number;
  idRequisit: number;
};

export const attachStatement = async (params: Params): Promise<void> => {
  const response = await customFetch(
    getM8AdminURL(`attachStatement?${createQueryString(params)}`),
    { method: 'POST' }
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
